export default "__VITE_ASSET__ba0c59de__"